export default {
  common: {
    next: 'Weiter',
    back: 'Zurück',
    submit: 'Absenden',
    cancel: 'Abbrechen',
    yes: 'JA',
    no: 'NEIN',
    required: '*',
    loading: 'Laden...',
    verifying: 'Überprüfung...',
    submitting: 'Wird gesendet...',
    startingForm: 'Formular wird gestartet...',
    startRegistration: 'Registrierung starten',
    selectCountry: 'Land auswählen',
    other: 'Andere',
    specify: 'Bitte angeben',
    note: 'Hinweis',
    instructions: 'Anleitung',
    securityNotice: 'Sicherheitshinweis',
    importantInfo: 'Wichtige Informationen'
  },
  
  nav: {
    home: 'Startseite'
  },
  
  home: {
    title: 'Registrierung und AML-Fragebogen',
    subtitle: 'Füllen Sie den AML-Fragebogen zur Identifizierung und Überprüfung des Kunden gemäß dem Gesetz Nr. 253/2008 Slg. über bestimmte Maßnahmen gegen die Legalisierung von Erträgen aus Straftaten und die Finanzierung des Terrorismus aus.',
    legalEntity: 'Juristische Person',
    legalEntityDesc: 'Formular für Unternehmen, Körperschaften und andere juristische Personen',
    physicalPerson: 'Natürliche Person',
    physicalPersonDesc: 'Formular für Einzelpersonen und natürliche Personen',
    importantInfoTitle: 'Wichtige Informationen',
    importantInfo1: 'Alle Daten werden sicher verschlüsselt',
    importantInfo2: 'Stellen Sie sicher, dass Sie alle erforderlichen Dokumente bereit haben (Personalausweis, Führerschein, ggf. Reisepass)',
    sessionError: 'Sitzung konnte nicht erstellt werden. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
    captchaError: 'Captcha-Überprüfung fehlgeschlagen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
    verifyFirst: 'Bitte bestätigen Sie zuerst, dass Sie kein Roboter sind.'
  },
  
  success: {
    title: 'Formular erfolgreich gesendet!',
    subtitle: 'Vielen Dank für das Ausfüllen des AML-Fragebogens. Ihre Daten wurden sicher gesendet und verarbeitet.',
    submissionDetails: 'Übermittlungsdetails',
    formType: 'Formulartyp',
    submissionId: 'Übermittlungs-ID',
    submissionTime: 'Übermittlungszeit',
    legalEntityLabel: 'Juristische Person',
    physicalPersonLabel: 'Natürliche Person',
    nextStepsTitle: 'Wie geht es weiter?',
    nextStep1: 'Ihre Daten wurden zur weiteren Bearbeitung übermittelt',
    nextStep2: 'Alle Daten sind sicher verschlüsselt',
    nextStep3: 'Wir werden Sie über die angegebenen Kontaktdaten kontaktieren',
    nextStep4: 'Die eingegebenen Daten wurden automatisch aus Ihrem Browser gelöscht, Sie können die Seite jetzt schließen',
    newForm: 'Neues Formular ausfüllen',
    contactUs: 'Bei Fragen kontaktieren Sie uns unter:'
  },
  
  notFound: {
    title: 'Seite nicht gefunden',
    message: 'Die angeforderte Seite existiert nicht.',
    backHome: 'Zurück zur Startseite'
  },
  
  draftRecovery: {
    title: 'Entwurf gefunden',
    message: 'Sie haben einen Entwurf für',
    legalEntityLabel: 'Juristische Person',
    physicalPersonLabel: 'Natürliche Person',
    question: 'Was möchten Sie tun?',
    continueDraft: 'Mit dem Entwurf fortfahren',
    startNew: 'Neu beginnen (löscht den Entwurf)'
  },
  
  validation: {
    fillAllFields: 'Bitte füllen Sie alle Pflichtfelder aus',
    invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    uploadAllDocuments: 'Bitte laden Sie alle 4 Seiten der Dokumente hoch (2 Dokumente × 2 Seiten)',
    selectTwoDocuments: 'Sie müssen genau 2 Dokumententypen auswählen',
    icoLength: 'Die Identifikationsnummer muss 8 Ziffern haben'
  },
  
  documents: {
    title: 'Identitätsdokumente',
    selectTwoTypes: 'Wählen Sie 2 Arten von Identitätsdokumenten',
    idCard: 'Personalausweis',
    driverLicense: 'Führerschein',
    passport: 'Reisepass',
    frontSide: 'Vorderseite',
    backSide: 'Rückseite',
    uploadInstructions: 'Wählen Sie 2 von 3 verfügbaren Dokumententypen. Für jedes Dokument laden Sie 2 Fotos hoch - Vorder- und Rückseite.',
    securityNotice: 'Diese Dokumente enthalten sensible persönliche Daten. Die Dateien werden vor dem Senden sicher verschlüsselt und nach erfolgreichem Absenden des Formulars automatisch von Ihrem Gerät gelöscht.',
    requirements: {
      imagesOnly: 'Nur Bilder (JPG, PNG)',
      maxSize: 'Maximale Größe: 10MB',
      readable: 'Das Dokument muss gut lesbar sein'
    }
  },
  
  fileUpload: {
    allowedFormats: 'Erlaubte Formate: PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, JPEG',
    maxSize: 'Maximale Dateigröße: 10MB',
    companyDocReq: 'Die juristische Person muss einen Nachweis über die Existenz der juristischen Person vorlegen (Handelsregisterauszug usw.)'
  },
  
  physicalPerson: {
    step1: {
      title: 'SCHRITT 1 - Identifikationsdaten des Kunden',
      firstName: 'Vorname',
      lastName: 'Nachname',
      birthNumber: 'Geburtsnummer (falls nicht vorhanden, Geburtsdatum eingeben)',
      birthNumberPlaceholder: '123456/7890 oder TT.MM.JJJJ',
      birthPlace: 'Geburtsort (Stadt und Land)',
      birthPlacePlaceholder: 'Prag, Tschechische Republik',
      address: 'Ständiger oder anderer Wohnsitz / Sitz',
      addressPlaceholder: 'Adresse eingeben',
      citizenship: 'Staatsangehörigkeit',
      citizenshipPlaceholder: 'Tschechische Republik',
      phone: 'Telefon',
      phonePlaceholder: '+420 123 456 789',
      email: 'E-Mail',
      emailPlaceholder: 'email@ihrfirma.cz',
      taxResidence: 'Steuerlicher Wohnsitz',
      taxResidencePlaceholder: 'CZ',
      identityDocumentsTitle: 'Identitätsdokumente der natürlichen Person (Kunde)'
    },
    step2: {
      title: 'SCHRITT 2 - Vertretung des Kunden',
      hasRepresentative: 'Wird der Kunde vertreten?',
      representativeNote: '(Person, die im Namen des Kunden bei dem Geschäft handelt)',
      noRepresentativeInfo: 'Der Kunde wird nicht vertreten. Bitte fahren Sie mit Schritt 4 fort.',
      hasRepresentativeInfo: 'Der Kunde wird vertreten. Im nächsten Schritt werden Sie die Daten des Vertreters ausfüllen.'
    },
    step3: {
      title: 'SCHRITT 3 - Angaben zum Vertreter',
      skipNotice: 'Dieser Schritt wird übersprungen, da der Kunde nicht vertreten wird.',
      continueToStep4: 'Weiter zu Schritt 4',
      representationType: 'Art der Vertretung',
      nameLabel: 'Vor- und Nachname / Firma / Name',
      namePlaceholder: 'Namen oder Firmennamen eingeben',
      gender: 'Geschlecht',
      taxResidenceNote: 'Ist kein Land angegeben, erklärt der Kunde, dass er nur in dem Land steuerlich ansässig ist, in dem sich sein ständiger Wohnsitz befindet. Im Allgemeinen gilt für die Bestimmung des steuerlichen Wohnsitzes des Kunden die Regel, dass er in dem Land steuerlich ansässig ist, in dem er sich mindestens 183 Tage im Jahr aufhält, sofern dieses Land keine anderen Regeln für die Bestimmung des steuerlichen Wohnsitzes festlegt.',
      guardianNote: '(Der Betreuer ist verpflichtet, die entsprechende Gerichtsentscheidung vorzulegen.)',
      identityDocumentsTitle: 'Identitätsdokumente des Vertreters der natürlichen Person'
    },
    step4: {
      title: 'SCHRITT 4 - Kundenprüfung - Einkommensquellen',
      incomeSource: 'Einkommensquellen',
      otherIncomeSource: 'Andere Einkommensquelle angeben',
      otherIncomePlaceholder: 'Andere Einkommensquelle eingeben',
      incomeNature: 'Art der vorherrschenden Einkommensquelle (Branche)',
      incomeNaturePlaceholder: 'z.B. IT-Dienstleistungen, Handel, Produktion...',
      annualIncome: 'Netto-Jahreseinkommen / Jahresumsatz',
      annualIncomePlaceholder: 'Jahreseinkommen/-umsatz eingeben',
      incomeSourceNature: 'Art der vorherrschenden Einkommensquelle',
      incomeSourceNaturePlaceholder: 'Detaillierte Beschreibung der Art der vorherrschenden Einkommensquelle',
      netAnnualIncome: 'Netto-Jahreseinkommen',
      netAnnualIncomePlaceholder: 'Netto-Jahreseinkommen eingeben'
    },
    step5: {
      title: 'SCHRITT 5 - Erwartete Transaktionen',
      monthlyVolume: 'Erwartetes monatliches Transaktionsvolumen',
      monthlyVolumePlaceholder: 'Erwartetes monatliches Transaktionsvolumen eingeben',
      paymentPurpose: 'Erwarteter Zahlungszweck',
      paymentPurposePlaceholder: 'Erwarteten Zahlungszweck eingeben',
      transactionType: 'Häufigste Art von Transaktionen bei Auszahlungen',
      transactionTypePlaceholder: 'Häufigste Art von Transaktionen bei Auszahlungen eingeben'
    },
    step6: {
      title: 'SCHRITT 6 - Politisch exponierte Person und internationale Sanktionen',
      isPEP: 'Sind Sie eine politisch exponierte Person?',
      pepDetails: 'Bitte angeben',
      pepDetailsPlaceholder: 'Funktion oder Position angeben',
      pepNote: 'a) eine natürliche Person, die eine wichtige öffentliche Funktion von nationaler oder regionaler Bedeutung ausübt oder ausgeübt hat, wie z.B. Staatsoberhaupt, Regierungschef, Leiter einer zentralen Staatsbehörde und dessen Stellvertreter (Stellvertreter, Staatssekretär), Mitglied des Parlaments, Mitglied des Leitungsorgans einer politischen Partei, führender Vertreter der Gebietsselbstverwaltung (Bürgermeister, Gouverneur), Richter des Obersten Gerichts, des Verfassungsgerichts oder eines anderen obersten Justizorgans, gegen dessen Entscheidung in der Regel keine Rechtsmittel eingelegt werden können, Mitglied des Bankenrates der Zentralbank, hoher Offizier der Streitkräfte oder des Korps, Mitglied oder Vertreter eines Mitglieds, wenn es sich um eine juristische Person handelt, des gesetzlichen Organs einer vom Staat kontrollierten Handelsgesellschaft, Botschafter oder Leiter einer diplomatischen Mission, oder eine natürliche Person, die eine ähnliche Funktion in einem anderen Staat, in einem Organ der Europäischen Union oder in einer internationalen Organisation ausübt oder ausgeübt hat.',
      isSanctioned: 'Unterliegen Sie Sanktionen der Tschechischen Republik oder internationalen Sanktionen',
      sanctionDetails: 'Bitte angeben',
      sanctionDetailsPlaceholder: 'Art und Umfang der Sanktionen angeben',
      sanctionNote: 'Unter internationalen Sanktionen versteht man gemäß Gesetz Nr. 69/2006 Slg. über internationale Sanktionen einen Befehl, ein Verbot oder eine Einschränkung zum Zweck der Aufrechterhaltung oder Wiederherstellung des internationalen Friedens und der Sicherheit, der Bekämpfung des Terrorismus, der Einhaltung des internationalen Rechts, des Schutzes der Menschenrechte und Grundfreiheiten und der Unterstützung von Demokratie und Rechtsstaatlichkeit.'
    },
    step7: {
      title: 'SCHRITT 7 - Absenden und Unterschrift',
      legalNotice: 'Der Kunde nimmt zur Kenntnis und stimmt durch Unterzeichnung dieses Dokuments zu, dass die Gesellschaft die personenbezogenen Daten des Kunden in dem Umfang verarbeitet, der für die Geltendmachung von Rechten und die Erfüllung von Pflichten aus geltenden Rechtsvorschriften und vertraglichen Vereinbarungen erforderlich ist, u.a. zum Zweck der Identifizierung und Überprüfung des Kunden gemäß Gesetz Nr. 253/2008 Slg. über bestimmte Maßnahmen gegen die Legalisierung von Erträgen aus Straftaten und die Finanzierung des Terrorismus.',
      clientStatement: 'Erklärung des Kunden:',
      clientStatementText: 'Ich bestätige, dass alle oben genannten Angaben vollständig und wahrheitsgemäß sind, dass ich keine wichtigen Informationen verschwiegen habe, die mir bekannt sind oder sein könnten, und ich verpflichte mich, der Gesellschaft Änderungen unverzüglich mitzuteilen.',
      signature: 'Unterschrift des Kunden (vollständigen Namen eingeben)',
      signaturePlaceholder: 'Geben Sie Ihren vollständigen Namen als elektronische Unterschrift ein',
      signatureNote: 'Mit der Eingabe Ihres vollständigen Namens bestätigen Sie die Richtigkeit aller Angaben',
      finalConfirmation: 'Ich bestätige, dass ich alle genannten Bedingungen gelesen habe und ihnen zustimme und dass alle bereitgestellten Informationen wahr und vollständig sind.',
      dataProcessingNotice: 'Informationen zur Datenverarbeitung:',
      dataProcessingText: 'Ihre Daten werden vor dem Senden an unseren Server sicher verschlüsselt. Nach erfolgreichem Absenden werden alle lokalen Daten automatisch von Ihrem Gerät gelöscht.',
      submitButton: 'REGISTRIERUNG NATÜRLICHE PERSON ABSENDEN'
    }
  },
  
  legalEntity: {
    step1: {
      title: 'SCHRITT 1 - Identifikationsdaten des Kunden',
      companyDocumentsLabel: 'Firma / Andere Rechtsform (einschließlich unterscheidender Zusatz oder weiterer Bezeichnung)',
      companyName: 'Firmenname',
      companyNamePlaceholder: 'Firmennamen eingeben',
      address: 'Sitz/Geschäftsadresse',
      addressPlaceholder: 'Firmensitz eingeben',
      ico: 'Identifikationsnummer (IČO)',
      icoPlaceholder: 'IČO eingeben',
      dic: 'Steuer-Identifikationsnummer (DIČ)',
      dicPlaceholder: 'DIČ eingeben (optional)',
      taxResidence: 'Steuerlicher Wohnsitz',
      registryInfo: 'Registereintragungsdaten',
      registryInfoPlaceholder: 'Registereintragungsdaten eingeben',
      actualOwner: 'Tatsächlicher Eigentümer',
      actualOwnerPlaceholder: 'Gemäß § 4 Abs. 4 des Gesetzes Nr. 253/2008 Slg. über bestimmte Maßnahmen gegen die Legalisierung von Erträgen aus Straftaten und die Finanzierung des Terrorismus in der geltenden Fassung',
      phone: 'Telefon',
      phonePlaceholder: '+420 123 456 789',
      email: 'E-Mail',
      emailPlaceholder: 'email@ihrfirma.cz'
    },
    step2: {
      title: 'SCHRITT 2 - Angaben zur natürlichen Person, die berechtigt ist, für den Kunden - juristische Person zu handeln',
      note: 'Handelt die natürliche Person auf der Grundlage einer Vollmacht für die juristische Person, ist sie verpflichtet, diese schriftliche Vollmacht vorzulegen. Handelt sie als Arbeitnehmer, muss die natürliche Person einen Arbeitsvertrag und eine Ermächtigung vorlegen, die sie berechtigt, für die juristische Person zu handeln. Hat die juristische Person eine andere Vertretung, muss die entsprechende Gerichtsentscheidung oder ein anderes Dokument vorgelegt werden, auf dessen Grundlage diese natürliche Person handelt.',
      representation: 'Vertretung durch das gesetzliche Organ',
      representationPlaceholder: 'Vertretungsart auswählen',
      firstName: 'Vorname',
      firstNamePlaceholder: 'Vornamen eingeben',
      lastName: 'Nachname',
      lastNamePlaceholder: 'Nachnamen eingeben',
      birthNumber: 'Geburtsnummer (falls nicht vorhanden, Geburtsdatum eingeben)',
      birthNumberPlaceholder: '123456/7890 oder TT.MM.JJJJ',
      birthPlace: 'Geburtsort (Stadt und Land)',
      birthPlacePlaceholder: 'Prag, Tschechische Republik',
      address: 'Ständiger oder anderer Wohnsitz / Sitz',
      addressPlaceholder: 'Adresse eingeben',
      gender: 'Geschlecht',
      citizenship: 'Staatsangehörigkeit',
      citizenshipPlaceholder: 'Tschechische Republik',
      phone: 'Telefon',
      phonePlaceholder: '+420 123 456 789',
      email: 'E-Mail',
      emailPlaceholder: 'email@ihrfirma.cz',
      taxResidence: 'Steuerlicher Wohnsitz',
      taxResidencePlaceholder: 'Tschechische Republik',
      isPEP: 'Sind Sie eine politisch exponierte Person?',
      pepDetails: 'Bitte angeben',
      pepDetailsPlaceholder: 'Funktion oder Position angeben',
      pepNote: 'Eine politisch exponierte Person ist eine natürliche Person, die eine wichtige öffentliche Funktion von nationaler oder regionaler Bedeutung ausübt oder ausgeübt hat...',
      isSanctioned: 'Unterliegen Sie Sanktionen der Tschechischen Republik oder internationalen Sanktionen',
      sanctionDetails: 'Bitte angeben',
      sanctionDetailsPlaceholder: 'Art und Umfang der Sanktionen angeben'
    },
    step3: {
      title: 'SCHRITT 3 - Überprüfung der Identitätsdokumente der natürlichen Person, die berechtigt ist, für den Kunden zu handeln',
      instructions: 'Wählen Sie 2 von 3 verfügbaren Dokumententypen. Für jedes Dokument laden Sie 2 Fotos hoch - Vorder- und Rückseite.',
      selectDocuments: 'Wählen Sie 2 Arten von Identitätsdokumenten',
      securityNotice: 'Diese Dokumente enthalten sensible persönliche Daten. Die Dateien werden vor dem Senden sicher verschlüsselt und nach erfolgreichem Absenden des Formulars automatisch von Ihrem Gerät gelöscht.'
    },
    step4: {
      title: 'SCHRITT 4 - Kundenprüfung',
      incomeSource: 'Einkommensquellen',
      otherIncomeSource: 'Andere Einkommensquelle angeben',
      otherIncomePlaceholder: 'Andere Einkommensquelle eingeben',
      incomeNature: 'Art der vorherrschenden Einkommensquelle (Branche)',
      incomeNaturePlaceholder: 'z.B. IT-Dienstleistungen, Handel, Produktion...',
      annualIncome: 'Netto-Jahreseinkommen / Jahresumsatz',
      annualIncomePlaceholder: 'Jahreseinkommen/-umsatz eingeben'
    },
    step5: {
      title: 'SCHRITT 5 - Erwartete Transaktionen',
      monthlyVolume: 'Erwartetes monatliches Transaktionsvolumen',
      monthlyVolumePlaceholder: 'Erwartetes monatliches Transaktionsvolumen eingeben',
      paymentPurpose: 'Erwarteter Zahlungszweck',
      paymentPurposePlaceholder: 'Erwarteten Zahlungszweck eingeben',
      transactionType: 'Häufigste Art von Transaktionen bei Auszahlungen',
      transactionTypePlaceholder: 'Häufigste Art von Transaktionen bei Auszahlungen eingeben'
    },
    step6: {
      title: 'SCHRITT 6 - Absenden und Unterschrift',
      noteTitle: 'Hinweis:',
      legalNotice: 'Der Kunde nimmt zur Kenntnis und stimmt durch Unterzeichnung dieses Dokuments zu, dass die Gesellschaft die personenbezogenen Daten des Kunden in dem Umfang verarbeitet, der für die Geltendmachung von Rechten und die Erfüllung von Pflichten aus geltenden Rechtsvorschriften und vertraglichen Vereinbarungen erforderlich ist, u.a. zum Zweck der Identifizierung und Überprüfung des Kunden gemäß Gesetz Nr. 253/2008 Slg. über bestimmte Maßnahmen gegen die Legalisierung von Erträgen aus Straftaten und die Finanzierung des Terrorismus.',
      clientStatement: 'Erklärung des Kunden:',
      clientStatementText: 'Ich bestätige, dass alle oben genannten Angaben vollständig und wahrheitsgemäß sind, dass ich keine wichtigen Informationen verschwiegen habe, die mir bekannt sind oder sein könnten, und ich verpflichte mich, der Gesellschaft Änderungen unverzüglich mitzuteilen.',
      signature: 'Unterschrift des Kunden (vollständigen Namen eingeben)',
      signaturePlaceholder: 'Geben Sie Ihren vollständigen Namen als elektronische Unterschrift ein',
      signatureNote: 'Mit der Eingabe Ihres vollständigen Namens bestätigen Sie die Richtigkeit aller Angaben',
      finalConfirmation: 'Ich bestätige, dass ich alle genannten Bedingungen gelesen habe und ihnen zustimme und dass alle bereitgestellten Informationen wahr und vollständig sind.',
      dataProcessingNotice: 'Informationen zur Datenverarbeitung:',
      dataProcessingText: 'Ihre Daten werden vor dem Senden an unseren Server sicher verschlüsselt. Nach erfolgreichem Absenden werden alle lokalen Daten automatisch von Ihrem Gerät gelöscht.',
      submitButton: 'REGISTRIERUNG JURISTISCHE PERSON ABSENDEN'
    }
  },
  
  options: {
    representationType: {
      statutory: 'Durch gesetzliches Organ',
      powerOfAttorney: 'Auf Grundlage einer Vollmacht',
      legalGuardian: 'Durch gesetzlichen Vertreter',
      guardian: 'Durch Betreuer'
    },
    legalRepresentationType: {
      powerOfAttorney: 'Auf Grundlage einer Vollmacht',
      employee: 'Als Arbeitnehmer',
      other: 'Andere Vertretung'
    },
    gender: {
      male: 'Männlich',
      female: 'Weiblich',
      other: 'Andere'
    },
    incomeSource: {
      employee: 'Arbeitnehmer',
      entrepreneur: 'Unternehmer',
      other: 'Andere (bitte angeben)'
    }
  },
  
  countries: {
    czechRepublic: 'Tschechische Republik',
    slovakRepublic: 'Slowakische Republik',
    poland: 'Polen',
    otherCountries: 'Andere Länder'
  }
}
